import { Component, Input, OnInit, TemplateRef } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { LetterRequestCustomer_Device_Interface } from 'src/app/Interface/LetterRequestCustomer_Device_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { LetterRequestCustomerService } from 'src/app/Service/Letter/LetterRequestCustomer.service';

@Component({
  selector: 'app-LetterRequestCustomerMissionActivityDevice',
  templateUrl: './LetterRequestCustomerMissionActivityDevice.component.html',
  styleUrls: ['./LetterRequestCustomerMissionActivityDevice.component.scss']
})
export class LetterRequestCustomerMissionActivityDeviceComponent implements OnInit {

  @Input() inner_Letter_id: number = 0

  Token: String = ""
  InProccessing: boolean = false

  constructor(
    private LetterRequestCustomer_Service: LetterRequestCustomerService,
    private modalService: BsModalService,
    private Alertify_Service: AlertifyService,
  ) { }

  ngOnInit() {
    this.Token = localStorage.getItem('Daro_User_Token');
    this.Read_DeviceLetterList_Seleted()
  }

  modalRef_Device: any;
  ProcssingDevice: boolean = false
  openModal_Device(template: TemplateRef<any>) {
    this.modalRef_Device = this.modalService.show(template);
  }

  DeviceLetterList: Array<LetterRequestCustomer_Device_Interface> = []
  Read_DeviceLetterList() {
    this.InProccessing = true
    this.LetterRequestCustomer_Service.GetActivityAvailableDevice(Number(this.inner_Letter_id), this.Token).subscribe(
      data => {
        this.DeviceLetterList = data
        this.InProccessing = false
      }
    )
  }

  Add_DeviceAll() {
    this.modalRef_Device.hide()
    this.InProccessing = true
    this.LetterRequestCustomer_Service.AddAllActivityDevice(Number(this.inner_Letter_id), this.Token).subscribe(
      data => {
        this.Read_DeviceLetterList()
        this.InProccessing = false
      }
    )
  }



  DeviceLetterList_Seleted: Array<LetterRequestCustomer_Device_Interface> = []
  Read_DeviceLetterList_Seleted() {
    this.InProccessing = true
    this.LetterRequestCustomer_Service.GetActivityDevice(Number(this.inner_Letter_id), this.Token).subscribe(
      data => {
        this.DeviceLetterList_Seleted = data
        this.InProccessing = false
      }
    )
  }

  Add_Device(item: LetterRequestCustomer_Device_Interface) {
    //this.modalRef_Device.hide()
    this.InProccessing = true
    this.LetterRequestCustomer_Service
      .AddActivityDevice(Number(item.id), Number(this.inner_Letter_id), this.Token).subscribe(
        data => {
          this.InProccessing = false
          if (data['id'] == 0) {
            this.Alertify_Service.ErrorMessage("The instrument cannot be added.")
          }
          else if (data['id'] == '-1') {
            this.Alertify_Service.ErrorMessage("The deletion deadline has passed.")
          }
          else {
            this.DeviceLetterList = []
            this.Read_DeviceLetterList_Seleted()
            this.Read_DeviceLetterList()
            this.Alertify_Service.SuccessMessage("The instrument was added successfully.")
          }
        }
      )
  }

  RemoveActivityDevice(item: LetterRequestCustomer_Device_Interface) {
    
    this.InProccessing = true
    this.LetterRequestCustomer_Service
      .RemoveActivityDevice(Number(item.id), Number(this.inner_Letter_id), this.Token).subscribe(
        data => {
          this.InProccessing = false
          if (data['id'] == '-1') {
            this.Alertify_Service.ErrorMessage("The registration deadline has passed.")
          }
          else {

            this.Read_DeviceLetterList_Seleted()
            this.Alertify_Service.SuccessMessage("The instrument was deleted successfully.")
            this.DeviceLetterList = []
          }
        }
      )
  }

  SwichActivityDevice(item: LetterRequestCustomer_Device_Interface) {
    
    this.InProccessing = true
    this.LetterRequestCustomer_Service
      .SwichActivityDevice(Number(item.id), this.Token).subscribe(
        data => {
          this.InProccessing = false
          this.Alertify_Service.SuccessMessage("The changes were applied successfully.")
          item.dscVisible=!item.dscVisible
        }
      )
  }

  SubmitDeviceMissionDsc(item: LetterRequestCustomer_Device_Interface) {
    
    this.InProccessing = true
    this.LetterRequestCustomer_Service
      .SubmitDeviceMissionDsc(item.dscMission ,Number(item.id), Number(this.inner_Letter_id), this.Token).subscribe(
        data => {
          this.InProccessing = false
          if (data['id'] == '-1') {
            this.Alertify_Service.ErrorMessage("The registration deadline has passed.")
          }
          else {
            this.Alertify_Service.SuccessMessage("The information was saved successfully.")
          }
        }
      )
  }



}
